"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualSocket = exports.Channel = exports.Duplexer = exports.RestoreStrategyBuilderFactory = void 0;
var wix_duplexer_protocol_1 = require("@wix/wix-duplexer-protocol");
Object.defineProperty(exports, "RestoreStrategyBuilderFactory", { enumerable: true, get: function () { return wix_duplexer_protocol_1.RestoreStrategyBuilderFactory; } });
var duplexer_1 = require("./duplexer");
Object.defineProperty(exports, "Duplexer", { enumerable: true, get: function () { return duplexer_1.Duplexer; } });
var channel_1 = require("./channels/channel");
Object.defineProperty(exports, "Channel", { enumerable: true, get: function () { return __importDefault(channel_1).default; } });
var virtual_socket_1 = require("./virtual-socket");
Object.defineProperty(exports, "VirtualSocket", { enumerable: true, get: function () { return __importDefault(virtual_socket_1).default; } });
//# sourceMappingURL=index.js.map